<app-section-loader [loading]="loading"></app-section-loader>
<link rel="shortcut icon" href="#" />
<div class="scroll page-bg flex-fill overflow-auto py-3 px-5 centerform">
  <div class="container p-0">
    <form [formGroup]="tutorForm">
      <div class="mControls">
        <div class="input-group mr-auto">
          <h1 class="m-0 text-white align-items-center d-inline-flex">
            {{
              editTutor
                ? "Update " +
                  tutorToEdit?.first_name +
                  " " +
                  tutorToEdit?.last_name
                : "Create New Volunteer"
            }}
          </h1>
        </div>
        <div class="mControls__right">
          <div class="input-group">
            <button type="button" mat-raised-button (click)="_location.back()">
              Cancel
            </button>
          </div>
          <div class="input-group">
            <button
              mat-raised-button
              color="primary"
              [disabled]="!tutorForm.valid || !schoolIds?.length"
              (click)="updateVolunteer(tutorForm.value)"
            >
              Done
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-7 mb-3">
          <div class="card">
            <div class="card-header">General</div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <div class="border p-3">
                    <div class="d-flex mb-3">
                      <div class="fileUpload mb-2">
                        <div class="fileUpload__image">
                          <img
                            id="logo"
                            onerror="this.src='../../../../assets/images/avatar.svg';"
                            src="{{ tutorToEdit.profile_image_path }}"
                            alt="user name"
                          />
                        </div>
                        <div class="fileUpload__file">
                          <label for="imageUpload"></label>
                        </div>
                      </div>
                      <div
                        class="flex-fill d-flex flex-column align-items-start justify-content-center pl-4"
                      >
                        <p class="small text-center m-0">
                          <strong>1024x1024px</strong>
                        </p>
                        <div class="file-upload btn-only">
                          <input
                            type="file"
                            accept="image/x-png,image/jpeg"
                            (change)="filesSelect($event)"
                            id="uploader-input"
                            #fileInput
                          />
                          <button
                            mat-raised-button
                            (click)="fileInput.click()"
                            color="primary"
                          >
                            Browse
                          </button>
                        </div>
                        <p
                          *ngIf="imageSizeExceededError"
                          class="text-danger small m-0"
                        >
                          Image size must be less than 1MB.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>First Name</mat-label>
                    <input
                      maxlength="25"
                      placeholder="First Name"
                      matInput
                      name="firstName"
                      id="firstName"
                      type="text"
                      formControlName="first_name"
                      required
                    />
                    <mat-error
                      *ngIf="tutorForm.get('first_name').hasError('required')"
                      >First Name is required</mat-error
                    >
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Middle Name</mat-label>
                    <input
                      maxlength="25"
                      placeholder="Middle Name"
                      matInput
                      name="secondName"
                      id="secondName"
                      type="text"
                      formControlName="second_name"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Last Name</mat-label>
                    <input
                      maxlength="25"
                      placeholder="Last Name"
                      matInput
                      name="lastName"
                      id="lastName"
                      type="text"
                      formControlName="last_name"
                      required
                    />
                    <mat-error
                      *ngIf="tutorForm.get('last_name').hasError('required')"
                      >Last Name is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-lg-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email</mat-label>
                    <input
                      maxlength="50"
                      placeholder="Ex. johnsmith@bctcs.edu"
                      matInput
                      type="email"
                      name="email"
                      id="email"
                      type="email"
                      formControlName="email"
                      required
                    />
                    <mat-error
                      *ngIf="tutorForm.get('email').hasError('required')"
                      >Email is required</mat-error
                    >
                    <mat-error
                      *ngIf="tutorForm.get('email').hasError('pattern')"
                      >Please enter a valid email address
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Phone</mat-label>
                    <input
                      maxlength="12"
                      mask="000-000-0000"
                      placeholder="Ex. (555) 555-5555"
                      matInput
                      formControlName="phone"
                      required
                      type="text"
                    />
                    <mat-error
                      *ngIf="tutorForm.get('phone').hasError('required')"
                      >Phone is required</mat-error
                    >
                    <mat-error *ngIf="tutorForm.get('phone').hasError('email')"
                      >Please enter a valid Phone number
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Alternate Phone</mat-label>
                    <input
                      maxlength="12"
                      mask="000-000-0000"
                      placeholder="Ex. (555) 555-5555"
                      matInput
                      formControlName="second_phone"
                      type="text"
                    />
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-checkbox
                    formControlName="can_share_phone"
                    [(ngModel)]="checkBox"
                  >
                    Share phone numbers
                  </mat-checkbox>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Emergency Contact First Name</mat-label>
                    <input
                      maxlength="25"
                      matInput
                      type="text"
                      formControlName="emergency_contact_first_name"
                    />
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Emergency Contact Last Name</mat-label>
                    <input
                      maxlength="25"
                      matInput
                      type="text"
                      formControlName="emergency_contact_last_name"
                    />
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Emergency Contact Phone</mat-label>
                    <input
                      matInput
                      maxlength="25"
                      mask="000-000-0000"
                      placeholder="Ex. (555) 555-5555"
                      formControlName="emergency_contact_number"
                    />
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Preferences </mat-label>
                    <mat-select formControlName="preference" required>
                      <mat-option
                        *ngFor="let brand of preferences"
                        [value]="brand.id"
                      >
                        {{ brand.preference_color_name | titlecase }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="tutorForm.get('preference').hasError('required')"
                      >Preference is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Roles </mat-label>
                    <mat-select formControlName="role" required>
                      <mat-option
                        *ngFor="let brand of roles"
                        [value]="brand.id"
                      >
                        {{ brand.role | titlecase }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="tutorForm.get('role').hasError('required')"
                      >Role is required</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 mb-3">
          <div class="card">
            <div class="card-header">Program Details</div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Commitment Level</mat-label>
                    <mat-select formControlName="commitment_level" required>
                      <mat-option
                        *ngFor="let brand of commitmentLevels"
                        [value]="brand.id"
                      >
                        {{ brand.commitment_level | titlecase }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="
                        tutorForm.get('commitment_level').hasError('required')
                      "
                      >Commitment level is required</mat-error
                    >
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Associated School(s)</mat-label>
                    <mat-select
                      disableOptionCentering
                      multiple
                      formControlName="schools"
                      [(value)]="schoolIds"
                      (selectionChange)="schoolSelected($event)"
                      required
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          style="width: 100%"
                          [formControl]="schoolControl"
                          [noEntriesFoundLabel]="'No matching School found'"
                          placeholderLabel="Search School"
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option
                        *ngFor="let school of schoolOptions"
                        [value]="school.id"
                        [disabled]="
                          school.tutor_limit - school.associated_tutor_count ===
                          0 && school.uuid!=sesssionConstants.trainingSchoolUuid
                        "
                      >
                        {{ school?.school_name }}
                        <ng-container *ngIf="school.uuid!=sesssionConstants.trainingSchoolUuid">
                          ({{
                          school.tutor_limit - school.associated_tutor_count
                          }}
                          slots available)
                        </ng-container>
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="tutorForm.get('schools').hasError('required')"
                      >School is required</mat-error
                    >
                  </mat-form-field>
                  <div
                    class="added-list hug--max-h"
                    *ngIf="selectedSchools?.length"
                  >
                    <div
                      class="list-loop mr-2"
                      *ngFor="let sch of selectedSchools"
                    >
                      <div class="d-flex align-items-center">
                        <div
                          class="flex-fill mr-2"
                          matTooltip="{{ sch?.school_name }} {{
                            sch?.uuid ? '(' + sch?.uuid + ')' : ''
                          }}"
                        >
                          {{ sch?.school_name }}
                          {{ sch?.uuid ? "(" + sch?.uuid + ")" : "" }}
                        </div>
                        <div class="flex-auto">
                          <span class="card-close pointer" onclick="">
                            <em
                              class="material-icons"
                              style="font-size: 12px"
                              (click)="schoolRemoved(sch.id)"
                              >close</em
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-8">
                  <mat-form-field appearance="outline" class="w-10">
                    <mat-label>Student Pairing Number</mat-label>
                    <mat-select>
                      <mat-option
                        *ngFor="let brand of pairingGroups"
                        [value]="brand.value"
                      >
                        {{ brand.display }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                ​
                <div class="col-12">
                  <mat-label>Qualifications</mat-label><br />
                  <mat-checkbox
                    class="mr-3"
                    formControlName="is_teacher_experience"
                    [(ngModel)]="teachingExperience"
                    name="teaching_experience"
                    >Teaching Experience</mat-checkbox
                  >
                  <mat-checkbox
                    class="mr-3"
                    formControlName="is_counselor_experience"
                    [(ngModel)]="counselorExperience"
                    name="counselor_experience"
                  >
                    Tutoring Experience</mat-checkbox
                  >
                  <mat-checkbox
                    class="mr-3"
                    formControlName="is_specialist"
                    [(ngModel)]="specialist"
                    name="specialist"
                  >
                    Specialist
                  </mat-checkbox>
                  <mat-checkbox
                    class="mr-3"
                    formControlName="is_background_checked"
                    [(ngModel)]="backgroundCheck"
                    name="background_check"
                    >Background Check
                  </mat-checkbox>
                  <mat-checkbox
                    class="mr-3"
                    formControlName="is_code_of_ethics"
                    name="code_of_ethics"
                    [(ngModel)]="codeOfEthics"
                  >
                    Code of Ethics</mat-checkbox
                  >
                  <div *ngIf="this.volunteerId">
                    <mat-checkbox
                      class="mr-3"
                      formControlName="is_deleted"
                      name="completed_shadow_days"
                      >Shadow Days</mat-checkbox
                    >
                  </div>
                </div>

                <div class="col-12 mt-2 mb-2">
                  <mat-label>Is this Tutor Certified?</mat-label><br />
                  <mat-radio-group
                    class="hug-form-radio-group"
                    formControlName="is_certified"
                    name="is_certified"
                  >
                    <mat-radio-button [value]="0">No</mat-radio-button>
                    <mat-radio-button [value]="1">Yes</mat-radio-button>
                  </mat-radio-group>
                </div>

                <div class="col-12">
                  <mat-form-field
                    class="w-100 no-error"
                    appearance="outline"
                    class="w-100"
                  >
                    <mat-label>Notes</mat-label>
                    <textarea
                      formControlName="note"
                      name=""
                      id="notes"
                      matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="4"
                      cdkAutosizeMaxRows="8"
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
